import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

const modalStyle = {
  width: '500px',
  height: '200px',
  marginLeft: '-10%'
}

const propTypes = {
  // selectedSalesOrder: PropTypes.object
}

const defaultProps = {
  // selectedSalesOrder: {},
}

const Confirmation = ({ onConfirm }) => {
  return (
    <div style={{ justifyContent: 'center', alignContent: 'center' }}>
      <h1 style={{ textAlign: 'center' }}>
        Void Selected Order?
      </h1>
      <Row className="centerStyle" style={{ marginTop: "50px" }}>
        <Button
          bsStyle="danger"
          onClick={(e) => {
            // this.handleOnSubmit(e);
            onConfirm();
          }}
        // disabled={!this.state.selectedDriver}
        >
          <Translate value="void" />
        </Button>
      </Row>
    </div>
  )
}

const Modal = ({ setModalVisibility, isVisible, onConfirm }) => (
  <SkyLightStateless
    title={'Confirmation'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <Confirmation onConfirm={onConfirm} setModalVisibility={setModalVisibility} />
  </SkyLightStateless>
)

Modal.propTypes = propTypes
Modal.defaultProps = defaultProps

export default Modal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/rma/Confirmation.jsx